import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './i18n/index.js'

// import "amfe-flexible"
// 导入element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/global.less'

import windowSizeMixin from '@/mixins/resize'

Vue.mixin(windowSizeMixin)

import removeAria from '@/utils/directive/removeAria.js'

//全局注册
Vue.directive('removeAria', removeAria)

Vue.use(ElementUI)
Vue.config.productionTip = false

const vueInstance = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app')

export default vueInstance
